import type { VariantUi } from './ui.ts';

export const classicUi: VariantUi = {
  heroImage: '/art/wN.svg',
  peek: [{}, {}, { image: '/art/bK.svg', threat: true }, {}, { image: '/art/wN.svg' }, {}, {}, {}, { image: '/art/bR.svg', threat: true }],
};
